<template>
  <el-card shadow="never" class="aui-card--fill">
   
    <div class="mod-loan__tproduct">
      债权转让协议签署方式：
     <hr>
     
     <el-form :model="dataForm" label-position="left" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '260px'">
        <el-form-item label="债权转让协议合同签署方式" prop="signingMethod" >
          <el-input
            placeholder="请输入内容"
            v-model="dataForm.signingMethod"
            :disabled="true">
          </el-input>
          <!-- <el-select v-model="dataForm.signingMethod" clearable placeholder="请选择">
          <el-option 
             v-for="item in transferList"
             :key="item.value"
             :label="item.label"
             :value="item.label"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="通知书模板">
        <el-select 
          v-model="dataForm.noticeTemplate" 
          clearable 
          :disabled="istransfer" 
          placeholder="请选择"
        >
          <el-option 
            v-for="item in noticeTemplates"
            :key="item.value"
            :label="item.label"
            :value="item.value" 
          ></el-option>
        </el-select>
    </el-form-item>
      <el-form-item label="债权转让协议通知书和回执单签署方式">
        <!-- <el-input
            placeholder="请输入内容"
            v-model="dataForm.notificationMethod"
            :disabled="true">
          </el-input> -->
          <el-select v-model="dataForm.notificationMethod" clearable :disabled="istransfer" placeholder="请选择">
          <el-option 
             v-for="item in transferList"
             :key="item.value"
             :label="item.label"
             :value="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="footer">
        <el-button >{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
      </div>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tproduct-add-or-update'
import debounce from 'lodash/debounce'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/loan/tproduct/page',
        getDataListIsPage: true,
        exportURL: '/loan/tproduct/export',
        deleteURL: '/loan/tproduct',
        deleteIsBatch: true
      },
      dataForm: {
        signingMethod: '线上',
        notificationMethod: '线上手动', //通知书
        noticeTemplate: 0 //通知书模板
      },
      transferList:[
        {label:'线上手动',value:1,},
        {label:'线上自动',value:2,},
        {label:'线下',value:3,}
      ],
      // 通知书模板
      noticeTemplates:[
        {label:'无回执',value:0,},
        {label:'有回执',value:1,}
      ]
    }
  },
  created() {
    this.dataForm.signingMethod = "线上"
    this.dataForm.notificationMethod = "线上手动"
    this.dataForm.noticeTemplate = 0
  },
  mounted(){
    this.getPerfectInfo()
  },
  methods:{
    submit(){
      console.log(this.dataForm)
    },
    getPerfectInfo(){
    this.$http.get('/loan/transfer/signingMethod').then(({data : res}) => {
      console.log(res)
      if(res.code != 0){
        this.$message.error( res.msg ) 
        return 
      } 
      this.dataForm.notificationMethod = res.data.notificationMethod ? res.data.notificationMethod : ''
      this.dataForm.signingMethod = res.data.signingMethod ? res.data.signingMethod  : ''
      this.dataForm.noticeTemplate = res.data.noticeTemplate ? res.data.noticeTemplate : 0
    })
  },
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http['post']('/loan/transfer/signingMethod', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          window.location.reload();
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  },

  computed: {
    istransfer(){
      this.dataForm.signingMethod == '线下签署' ?   this.dataForm.notificationMethod = '线下签署' : ''
      return this.dataForm.signingMethod == '线下签署' 
    },
    dataRule () {
      return {
        signingMethod: [
          {required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>

<style scoped lang="scss">
hr{
  margin: 20px 0px 30px 0px;
}
.footer{
  margin-left: 260px;
}
.el-input{
  width: 260px;
}

</style>
